import InputEditable from './InputEditable';

export default InputEditable;
